function configImagens() {

	$('.js-imagens-set-principal').click(function() {
		var id = $(this).attr('data-id');
		var imovel_id = $(this).attr('data-imovel-id');

		$.ajax({
			'url': baseurlc+"ajax_imagem_principal",
			'data': {'item_id': id, 'imovel_id': imovel_id},
			'method': 'POST'
		});
	});

	$('.js-imagens-toggle-ativo').click(function() {
		var valor = 0;
		var id = $(this).attr('data-id');

		if($(this).prop('checked')) {
			valor = 1;
		}

		$.ajax({
			'url': baseurlc+"ajax_imagem_ativo",
			'data': {'item_id': id, 'ativo': valor},
			'method': 'POST'
		});
	});
	
}

export default configImagens;
